import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { canUseDOM } from '../../helpers';
import { AlertGroupInline } from './AlertGroupInline';
export var AlertGroup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AlertGroup, _React$Component);

  function AlertGroup() {
    var _this;

    _classCallCheck(this, AlertGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlertGroup).apply(this, arguments));
    _this.state = {
      container: undefined
    };
    return _this;
  }

  _createClass(AlertGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = document.createElement('div');
      var target = this.getTargetElement();
      this.setState({
        container: container
      });
      target.appendChild(container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = this.getTargetElement();

      if (this.state.container) {
        target.removeChild(this.state.container);
      }
    }
  }, {
    key: "getTargetElement",
    value: function getTargetElement() {
      var appendTo = this.props.appendTo;

      if (typeof appendTo === 'function') {
        return appendTo();
      }

      return appendTo || document.body;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          isToast = _this$props.isToast;
      var alertGroup = React.createElement(AlertGroupInline, {
        className: className,
        isToast: isToast
      }, children);

      if (!this.props.isToast) {
        return alertGroup;
      }

      var container = this.state.container;

      if (!canUseDOM || !container) {
        return null;
      }

      return ReactDOM.createPortal(alertGroup, container);
    }
  }]);

  return AlertGroup;
}(React.Component);